import { noticeFailure, noticeSuccess } from "@self/notices";
import { makeStylesheetLink } from "@self/stylesheet";

export class RemoveCoupon extends HTMLElement {

	shadow: ShadowRoot;
	button: HTMLButtonElement;
	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button
			type="button"
			className="gct-cart-btn"
			innerHTML={"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M7.27494 17.6542L6.34619 16.7254L11.0712 12.0004L6.34619 7.27543L7.27494 6.34668L11.9999 11.0717L16.7249 6.34668L17.6537 7.27543L12.9287 12.0004L17.6537 16.7254L16.7249 17.6542L11.9999 12.9292L7.27494 17.6542Z\" fill=\"#747474\"/></svg>"}
		/> as HTMLButtonElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(this.button);

		this.shadow.append(this.button, makeStylesheetLink());
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: RemoveCoupon) {
	try {
		this.button.disabled = true;

		const data = new URLSearchParams({
			"woocommerce-cart-nonce": this.dataset.nonce!,
		});

		await fetch(`${this.dataset.endpoint!}/?remove_coupon=${this.dataset.coupon!}`, {
			method: "POST",
			body: data,
			credentials: "include",
		});

		const res = await fetch(this.dataset.endpoint!, {
			method: "POST",
			body: data,
			credentials: "include",
		});

		const html = await res.text();
		const newDocument = new DOMParser().parseFromString(html, "text/html");
		document.body.innerHTML = newDocument.body.innerHTML;

		noticeSuccess("Coupon removed.");
	} catch (error) {
		if (error instanceof TypeError) {
			noticeFailure("Couldn't connect. Are you online?");
		} else {
			noticeFailure("There was an unexpected error.")
		}
	} finally {
		this.button.disabled = false;
	}
}
